import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/index';
// import { appUtil } from '@utils';
import { NzMessageService } from 'ng-zorro-antd/message';

@Injectable()
export class HttpService {
    configUrl;
    constructor(private http: HttpClient, private messageService: NzMessageService) {
        window.addEventListener('online', () => this.online());
        window.addEventListener('offline', () => this.offline());
    }

    get(path: string, params?: any, opts?: any): Observable<any> {
        return this.http.get(this.getPath(path, params), this.getOptions());
    }
    // 获取文件地址
    getFile(host: string, path: string, params?: any, opts?: any): Observable<any> {
        return this.http.get(this.getFilePath(host, path, params), this.getOptions());
    }

    post(path: string, data?: any): Observable<any> {
        const headers = new HttpHeaders()
            .set('Accept', 'application/x-javascript')
            // .set('Content-Type', 'text/csv;charset=utf-8')
            .set('Content-Type', 'application/json');
        let options;
        if (path.indexOf('excel_export') > -1) {
            options = { headers, withCredentials: true, responseType: 'text', observe: 'response' };
        } else {
            options = this.getOptions();
        }
        return this.http.post(this.getPath(path), data, options);
    }

    patch(path: string, data: any, params?: any): Observable<any> {
        return this.http.patch(this.getPath(path, params), data, this.getOptions());
    }

    put(path: string, data: any, params?: any): Observable<any> {
        return this.http.put(this.getPath(path, params), data, this.getOptions());
    }

    remove(path: string, params?: any): Observable<any> {
        return this.http.delete(this.getPath(path, params), this.getOptions());
    }
    getPath(path: string, params?: any): string {
        if (params) {
            path = [path, this.getQueryString(params)].join('?');
        }
        return path;
    }
    /**
     * 获取文件地址
     */
    getFilePath(host, path, params): string {
        if (params) {
            path = [path, this.getQueryString(params)].join('?');
        }
        return host + path;
    }
    private getOptions(): any {
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        return { headers, withCredentials: true };
    }
    getQueryString(params: any): string {
        if (!params) {
            return '';
        }
        // 转义中括号
        const leftBracket = encodeURIComponent('[');
        const rightBracket = encodeURIComponent(']');
        const keys = Object.keys(params),
            queryStringArr: any = [];
        for (let i = keys.length; i; i--) {
            const key = keys[i - 1],
                value = params[key];
            const keyValue = encodeURIComponent(key);
            if (typeof value === 'object') {
                const subKeys = Object.keys(value);
                for (let j = subKeys.length; j; j--) {
                    const subKey = subKeys[j - 1];
                    const subKeyValue = encodeURIComponent(subKey);
                    const resultValue = encodeURIComponent(value[subKey]);
                    queryStringArr.push(`${keyValue}${leftBracket}${subKeyValue}${rightBracket}=${resultValue}`);
                    // queryStringArr.push(`${key}[${subKey}]=${value[subKey]}`);
                }
            } else {
                if (value !== 'all') {
                    const resultValue = encodeURIComponent(params[key]);
                    queryStringArr.push(`${keyValue}=${resultValue}`);
                    // queryStringArr.push(`${key}=${params[key]}`);
                }
            }
        }
        return queryStringArr.join('&');
        // return encodeURI(queryStringArr.join('&'));
    }

    formatParams(input): void {
        // return appUtil.filterParams(input);
    }

    /**
     * @desc 监听网络连接成功
     */
    online(): void {
        this.messageService.success('网络连接成功');
    }

    /**
     * @desc 监听网络断开连接
     */
    offline(): void {
        this.messageService.warning('网络未连接，请检查您的网络设置');
    }

    logout(): void {
        const path = '/api/logout';
        this.post(path, {}).subscribe((res) => {
            window.onbeforeunload = null;
            window.location.href = res.result.url;
        });
    }

    createA(url): void {
        const eleLink = document.createElement('a');
        eleLink.download = 'download';
        eleLink.style.display = 'none';
        eleLink.href = url;
        eleLink.target = '_blank';
        // 触发点击
        document.body.appendChild(eleLink);
        eleLink.click();
        // 然后移除
        document.body.removeChild(eleLink);
    }

    /**
     * GET 下载
     *
     * @param {string} url
     * @param {string} title
     * @memberof HttpService
     */
    getDownload(url: string, title: string): void {
        const xmlRes = new XMLHttpRequest();
        xmlRes.open('GET', url, true);
        xmlRes.responseType = 'blob';
        xmlRes.withCredentials = true;
        xmlRes.onload = (e) => {
            const newUrl = window.URL.createObjectURL(xmlRes.response);
            const aLink = document.createElement('a');
            aLink.href = newUrl;
            aLink.download = title;
            aLink.click();
        };
        xmlRes.send();
    }

    postFormData(url: string, formData: any, opts?: any): Observable<any> {
        return this.http.post(url, formData, { withCredentials: true });
    }

    putFormData(url: string, formData: any, opts?: any): Observable<any> {
        return this.http.put(url, formData, { withCredentials: true });
    }

    formatToFormData(data): FormData {
        const formData = new FormData();
        for (const key in data) {
            if (key) {
                if (typeof data[key] === 'string') {
                    data[key] = data[key].trim();
                }
                formData.append(key, data[key]);
            }
        }
        return formData;
    }
    createFormPost(url): void {
        const form = document.createElement('form');
        form.style.display = 'none';
        form.action = url;
        form.method = 'POST';
        document.body.appendChild(form);
        // for (let param in data) {
        //   const formInput = document.createElement('input')
        //   formInput.style.display = 'none'
        //   formInput.name = param
        //   formInput.value = data[param]
        //   form.appendChild(formInput)
        // }
        form.submit(); // 后台接收类型需使用 application/x-www-form-urlencoded  否则会报415
        document.body.removeChild(form);
    }
}

// @Injectable()
// export class NoopInterceptor implements HttpInterceptor {
//
//   intercept(req: HttpRequest<any>, next: HttpHandler):
//   Observable<HttpEvent<any>> {
//     Debug.log(req)
//     const host = window.location.host
//     Debug.log(host)
//     const secureReq = req.clone({
//       // url: req.url.replace('http://', 'https://')
//       url: `https://${host}${req.url}`
//     })
//     return next.handle(secureReq)
//   }
// }
